export default __webpack_public_path__ + "media/images/jvqmap/thumb-1bb1270c6f8540e746c41749a020bc20.jpg";